var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuotaCheckIconBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1665 7.5L7.0415 9.375L10.1665 5.625M2.6665 10.5001V4.50012C2.6665 3.80006 2.6665 3.44976 2.80275 3.18237C2.92259 2.94717 3.11367 2.75608 3.34888 2.63624C3.61627 2.5 3.96656 2.5 4.66663 2.5H10.6666C11.3667 2.5 11.7162 2.5 11.9836 2.63624C12.2188 2.75608 12.4106 2.94717 12.5304 3.18237C12.6665 3.4495 12.6665 3.79937 12.6665 4.49807V10.5022C12.6665 11.2009 12.6665 11.5503 12.5304 11.8174C12.4106 12.0526 12.2188 12.244 11.9836 12.3639C11.7165 12.5 11.3671 12.5 10.6684 12.5H4.66457C3.96588 12.5 3.61601 12.5 3.34888 12.3639C3.11367 12.244 2.92259 12.0526 2.80275 11.8174C2.6665 11.55 2.6665 11.2002 2.6665 10.5001Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotaCheckIconBlack);
export default __webpack_public_path__ + "static/media/quotaCheckIconBlack.ebf49f6349e7be68fb377ff43d1cb6f0.svg";
export { ForwardRef as ReactComponent };